import { RootState } from '../../../../store/types';
import { AdvancedLmState } from './reducer';

export const getCharmeterSSOToken = (state: RootState): string|undefined => state.advancedLm.ssoToken;
export const getCharmeterSSOTokenError = (state: RootState): any|undefined => state.advancedLm.error;
export const getShowHeader = (state: RootState): boolean|undefined => state.advancedLm.showInfoHeader;
